import React from "react";
import { Box } from "@mui/material";
import ProfileCard from "./compoments/ProfileCard";
import ClinicInfoCard from "./compoments/ClinicInfoCard";
import { useIsMobile } from "../../hooks/useIsMobile";

const ProfilePage: React.FC = () => {
  const isMobile = useIsMobile();

  return (
    <div
      style={{
        flex: 1,
        overflowY: "auto",
        padding: isMobile ? "0 8px" : "0 16px",
        display: "flex",
        flexDirection: "column",
        height: "100%",
        minHeight: 0,
        WebkitOverflowScrolling: "touch",
        boxSizing: "border-box",
      }}
    >
      <Box
        sx={{
          p: isMobile ? 1 : 4,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: isMobile ? 2 : 4,
          width: "100%",
          maxWidth: 1100,
          mx: "auto",
          boxSizing: "border-box",
        }}
      >
        <ProfileCard />
        <ClinicInfoCard />
      </Box>
    </div>
  );
};

export default ProfilePage;
